<template>
    <div class="internal-accounts p-2">
        <div class="row">
            <div class="col-12">
                <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 pt-2 mt-1 mb-3">
                    <div>
                        <h5 class="title mt-2 mb-1">Comptes admins</h5>
                        <p class="text-muted mb-0">Liste read-only des comptes administrateurs.</p>
                    </div>
                    <div class="d-flex align-items-center mt-2 mt-md-0">
                        <select v-model.number="limit" class="form-select form-select-sm me-2 select-native mb-0">
                            <option :value="50">50 lignes</option>
                            <option :value="100">100 lignes</option>
                            <option :value="200">200 lignes</option>
                        </select>
                        <button type="button" class="btn btn-sm btn-outline-secondary btn-square" @click="fetchInternalAccounts">
                            <feather type="refresh-cw" />
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <LoaderComponent v-if="loading" />
        <div v-else class="activity-section">
            <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="mb-0">Comptes admins</h6>
                <span class="text-muted small">{{ internalAccounts.length }} compte(s)</span>
            </div>
            <div v-if="internalAccounts.length === 0" class="empty-state">Aucun compte administrateur.</div>
            <div v-else class="table-responsive">
                <table class="table table-sm table-striped border-bottom mb-0">
                    <thead>
                        <tr>
                            <th>Rôle</th>
                            <th>Nom</th>
                            <th>Email</th>
                            <th>Date de création</th>
                            <th>Dernière connexion</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="account in internalAccounts" :key="account.id">
                            <td>
                                <span class="badge text-bg-secondary">{{ account.role }}</span>
                            </td>
                            <td>
                                <strong>{{ displayAccountName(account) }}</strong>
                                <div class="text-muted small">#{{ account.id }}</div>
                            </td>
                            <td>{{ account.email || "-" }}</td>
                            <td>{{ formatDate(account.created_at) }}</td>
                            <td>{{ formatDate(account.last_login_at, true) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import LoaderComponent from "../../components/LoaderComponent.vue";

export default {
    name: "InternalAccounts",
    data() {
        return {
            loading: false,
            limit: 100,
            internalAccounts: [],
        };
    },
    methods: {
        displayAccountName(account) {
            const fullname = `${account.firstname || ""} ${account.lastname || ""}`.trim();

            return fullname || account.email || `Compte #${account.id}`;
        },
        formatDate(date, withTime = false) {
            if (!date) {
                return "-";
            }

            return this.displayDate(date, withTime ? this.DATETIME_SHORT : this.DATE_SHORT);
        },
        fetchInternalAccounts() {
            this.loading = true;

            this.httpGet(`/api/admin/internal_accounts?limit=${this.limit}`)
                .then((response) => {
                    if (response === false) {
                        return;
                    }

                    this.internalAccounts = response.data.data || [];
                })
                .finally(() => (this.loading = false));
        },
    },
    watch: {
        limit() {
            this.fetchInternalAccounts();
        },
    },
    components: {
        LoaderComponent,
    },
    created() {
        this.fetchInternalAccounts();
    },
};
</script>

<style>
.internal-accounts {
    width: 100%;
    max-width: 1180px;
    margin-right: auto;
    margin-left: auto;
}

.internal-accounts .activity-section {
    padding: 14px;
    border: 1px solid #d9e4ec;
    border-radius: 6px;
    background: #fff;
}

.internal-accounts .activity-section h6 {
    color: #182b3c;
    font-size: 0.98rem;
    font-weight: 700;
}

.internal-accounts .empty-state {
    padding: 18px;
    border: 1px dashed #ced8e1;
    border-radius: 6px;
    color: #627184;
    text-align: center;
}
</style>
